import React from 'react';
import JobWaiting from './JobWaiting';
import Modal from '../../../../Components/Modal/Modal';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import styles from './JobWaitingModal.module.scss';

interface Props {
	jobId: string;
	onJobSuccess: () => void;
	onJobFailed: () => void;
	onJobChained?: (chainedJobId: string) => void;
	waitingMessage: string;
	timeout: number;
	pollInterval?: number;
	onClose: () => void;
}

const JobWaitingModal: React.FC<Props> = ({
	onClose,
	jobId,
	onJobSuccess,
	onJobFailed,
	onJobChained,
	timeout,
	pollInterval,
	waitingMessage,
}) => {
	return (
		<Modal opened style={{ minWidth: 'auto' }}>
			<Modal.Content>
				<div className={styles.wrapper}>
					<div className={styles.header}>
						<LinkButton
							title='base.shared.close'
							onClick={onClose}
							theme={Theme.RED}
						/>
					</div>
					<JobWaiting
						jobId={jobId}
						onJobSuccess={onJobSuccess}
						onJobFailed={onJobFailed}
						onJobChained={onJobChained}
						waitingMessage={waitingMessage}
						timeout={timeout}
						pollInterval={pollInterval}
					/>
				</div>
			</Modal.Content>
		</Modal>
	);
};

export default JobWaitingModal;
